import makeRequest from "../api/makeRequest";
import url from "../api/urls";
import { RequstMethods } from "../api/requestMethode";

export class CandidateService {
    static async getAll(pageNumber: number, pageSize: number, search: string, approvalFilter: string) {
        const params = `?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}&approvalFilter=${approvalFilter}`;
        return await makeRequest(url.candidates.getAll + params, RequstMethods.GET);
    }

    static async getDetails(id: string) {
        return await makeRequest(url.candidates.getDetails + "/" + id, RequstMethods.GET);
    }

    static async approve(id: string, isApproved: boolean) {
        return await makeRequest(url.candidates.approve + "/" + id, RequstMethods.PUT, { isApproved });
    }

    static async edit(id: string, payload: any) {
        return await makeRequest(url.candidates.edit + "/" + id, RequstMethods.PUT, payload);
    }

    static async getExams(id: string) {
        return await makeRequest(url.candidates.getExams + "/" + id, RequstMethods.GET);
    }

    static async getTransactions(id: string) {
        return await makeRequest(url.candidates.getTransactions + "/" + id, RequstMethods.GET);
    }
}
